import {
  Box,
  Button,
  Drawer,
  FormControlLabel,
  Switch,
  Typography,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useForm, Controller } from "react-hook-form";
import { useEffect } from "react";
import styles from "./styles"; // optional, use if shared styles exist

interface ApprovalDrawerProps {
  drawerOpen: boolean;
  toggleDrawer: (open: boolean) => () => void;
  onSubmit: (approval: boolean) => void;
  initialApproval?: boolean;
}

type ApprovalFormInputs = {
  approval: boolean;
};

const ApprovalDrawer = ({
  drawerOpen,
  toggleDrawer,
  onSubmit,
  initialApproval = false,
}: ApprovalDrawerProps) => {
  const {
    handleSubmit,
    control,
    reset,
  } = useForm<ApprovalFormInputs>({
    defaultValues: { approval: initialApproval },
  });

  useEffect(() => {
    reset({ approval: initialApproval }); 
  }, [initialApproval, reset]);

  const handleFormSubmit = (data: ApprovalFormInputs) => {
    onSubmit(data.approval);
    toggleDrawer(false)();
  };

  return (
    <Drawer anchor="right" open={drawerOpen} onClose={toggleDrawer(false)} sx={styles.filterDrawer}>
      <Box
        component="form"
        onSubmit={handleSubmit(handleFormSubmit)}
        sx={{ ...styles.formContainer, padding: "1rem", width: 320 }}
      >
        <Typography sx={styles.subHeading}>Approval Settings</Typography>

        <IconButton
          onClick={toggleDrawer(false)}
          sx={{ position: "absolute", top: 8, right: 8 }}
        >
          <CloseIcon />
        </IconButton>

        <Box mt={3}>
          <Controller
            name="approval"
            control={control}
            render={({ field }) => (
              <FormControlLabel
                control={
                  <Switch
                    {...field}
                    checked={field.value}
                    onChange={(e) => field.onChange(e.target.checked)}
                    color="primary"
                  />
                }
                label={
                  field.value
                    ? "Automatic Approval Enabled"
                    : "Automatic Approval Disabled"
                }
              />
            )}
          />
        </Box>

        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            gap: "8px",
            marginTop: "2rem",
            paddingBottom: "3rem",
          }}
        >
          <Button
            variant="outlined"
            color="secondary"
            fullWidth
            onClick={() => {
              reset({ approval: false });
              onSubmit(false); // Optional: immediate callback
              toggleDrawer(false)();
            }}
          >
            Clear
          </Button>

          <Button type="submit" variant="contained" color="primary" fullWidth>
            Save
          </Button>
        </Box>
      </Box>
    </Drawer>
  );
};

export default ApprovalDrawer;
